import { LearningDashboardLoadingView } from '@/views/dashboards-learning/dashboards-learning.loading';

export default LearningDashboardLoadingView;
